import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { LoadingWorld } from "./components/LoadingWorld";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const WorldModule = lazy(() => import("./pages/WorldModule"));
const Admin = lazy(() => import("./pages/Admin"));
const Login = lazy(() => import("./pages/Login"));
const Setup = lazy(() => import("./pages/Setup"));

export default function App() {
  return (
    <Suspense fallback={<LoadingWorld />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/setup" element={<Setup mode="bootstrap" />} />
        <Route path="/join" element={<Setup mode="join" />} />
        <Route element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="world/:module" element={<WorldModule />} />
          <Route path="admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
